import type React from "react";
import { useDeals } from "~/hooks/useDeals";
import { useIdQueryHandler } from "~/hooks/useIdQueryHandler";
import type { DealBillingContext } from "~/models/DealBilling";
import { toThousandSeparator } from "~/utils/CurrencySeparator";
import Styles from "./SettlementList.module.scss";

type Props = {
	constructionContext: DealBillingContext;
	target: "owner" | "rentee";
};

/**
 * 精算項目テーブル原状回復・修繕費用出力行
 *
 * @for clients
 */

export const SettlementListRestorationAmountRow: React.FC<Props> = ({
	constructionContext,
	target
}: Props) => {
	const id = useIdQueryHandler();
	const { data: deal } = useDeals().show(id);
	const expensesLabel = (): string => {
		if (deal?.dealType === "restoration") return "原状回復費用";
		if (deal?.dealType === "repair") return "修繕費用";
		return "施工費用";
	};
	const {
		sumOwnerAmount,
		sumOwnerAmountWithTax,
		sumRenteeAmount,
		sumRenteeAmountWithTax
	} = constructionContext;
	const isOwner = target === "owner";
	const totalAmount = isOwner ? sumOwnerAmount : sumRenteeAmount;
	const totalAmountWithTax = isOwner
		? sumOwnerAmountWithTax
		: sumRenteeAmountWithTax;
	return (
		<tr className={Styles.ListRow}>
			<td className={Styles.Select} />
			<td className={Styles.OrderHandle} />
			<td className={Styles.Settlement}>{expensesLabel()}</td>
			<td className={Styles.NonTaxAmount}>
				¥{toThousandSeparator(totalAmount)}
			</td>
			<td className={Styles.TaxRate}>10%</td>
			<td className={Styles.TaxAmount}>
				¥{toThousandSeparator(totalAmountWithTax)}
			</td>
			<td className={Styles.Edit} />
		</tr>
	);
};
